(function () {
    if (window.__rebuyCartSyncInitialized) {
        return;
    }
    window.__rebuyCartSyncInitialized = true;

    // Rebuy widgets (eg. cart drawer recommendations) add to the Shopify cart directly via
    // their own JS, bypassing the theme's `product-form` submit flow, so `cart-count` and
    // `cart-drawer` never hear about it. Rebuy's Cart module dispatches `rebuy:cart.add` /
    // `rebuy:cart.change` on every cart mutation regardless of source, so we use those as the
    // signal to trigger the theme's own full cart refresh (same mechanism used on cart errors).
    document.addEventListener('rebuy:cart.add', requestThemeCartRefresh);
    document.addEventListener('rebuy:cart.change', requestThemeCartRefresh);

    function requestThemeCartRefresh() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
})();
